import React from 'react';

import { Text, TextProps } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { Event } from '@/feature/event-details-sbk/types';
import { useEventWinningSide, useTeamScore } from '@/hooks/use-sbk-event-details-cache';

type TeamScoreProps = {
    event: Event;
    side: 'home' | 'away';
} & TextProps;

export const isLosingSide = (side: 'home' | 'away', winningSide?: 'home' | 'away' | 'draw') => {
    return (side === 'home' && winningSide === 'away') || (side === 'away' && winningSide === 'home');
};

export const getTextColor = (side: 'home' | 'away', winningSide?: 'home' | 'away' | 'draw') => {
    // todo-color-migration - we should diff between these as they were white for winning and neutral100 for losing
    return isLosingSide(side, winningSide) ? ds.colorToken.text.primary : ds.colorToken.text.secondary;
};

export const getTextOpacity = (side: 'home' | 'away', winningSide?: 'home' | 'away' | 'draw') => {
    return isLosingSide(side, winningSide) ? 0.6 : 1;
};

export const TeamScore = ({ event, side, ...textProps }: TeamScoreProps) => {
    const score = useTeamScore(event, side);
    const winningSide = useEventWinningSide(event);
    return (
        <Text color={getTextColor(side, winningSide)} opacity={getTextOpacity(side, winningSide)} {...textProps}>
            {score}
        </Text>
    );
};
